document.addEventListener('DOMContentLoaded', function () {
  // Function to process text nodes
  function processTextNodes(element) {
    // Skip non-text nodes and script/style elements
    if (element.nodeType === Node.TEXT_NODE) {
      const parent = element.parentElement
      if (parent && parent !== document.body) {
        const computedStyle = window.getComputedStyle(parent)
        const fontFamily = computedStyle.fontFamily.toLowerCase()
        if (fontFamily.includes('p22-mackinac') && element.nodeValue.includes('-')) {
          // Create a temporary container to hold replaced content
          const span = document.createElement('span')
          span.innerHTML = element.nodeValue.replace(/-/g, '<span class="custom-hyphen">-</span>')
          // Replace the text node with the new content
          element.replaceWith(...span.childNodes)
        }
      }
    } else if (element.nodeType === Node.ELEMENT_NODE && element.tagName !== 'SCRIPT' && element.tagName !== 'STYLE') {
      // Recursively process child nodes
      Array.from(element.childNodes).forEach(processTextNodes)
    }
  }

  // Start processing from the body
  processTextNodes(document.body)
})
